import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ToolState } from '@models/tool.model';

export const selectToolState = createFeatureSelector<ToolState>('tools');
export const selectActiveTool    = createSelector(selectToolState, s => s.activeTool);
export const selectActiveColor   = createSelector(selectToolState, s => s.activeColor);
export const selectRecentColors  = createSelector(selectToolState, s => s.recentColors);
export const selectBrushSize     = createSelector(selectToolState, s => s.brushSize ?? 1);
export const selectSymmetryMode  = createSelector(selectToolState, s => s.symmetryMode ?? 'none');
export const selectShapeFillMode = createSelector(selectToolState, s => s.shapeFillMode ?? 'outline');
